import http from '../request.js'

export default {
  list: (data) => {
    return http({
      url: '/api/order/list',
      data
      // aaaaaa: 111
    })
  },

  add: (data) => {
    return http({
      url: '/api/order/save',
      data
    })
  },

  add2: (data) => {
    return http({
      url: '/api/order/save2',
      data
    })
  },

  delete: (data) => {
    return http({
      url: '/api/order/delete',
      data
    })
  },

  userList: (data) => {
    return http({
      url: '/api/order/user_list',
      data
    })
  },

  refund: (data) => {
    return http({
      url: '/api/order/checkRefund',
      data
    })
  },

  invoice: (data) => {
    return http({
      url: '/api/order/invoiceJson',
      data
    })
  },

  cancel: (data) => {
    return http({
      url: '/api/order/cancel',
      data
    })
  }
}
